<template>
    <div class="text-center mx-auto my-6 w-full flex-none">
        <img src="@/assets/img/logo/buzzebees-logo-dark.svg" class="mx-auto" alt />
    </div>
</template>
<script>
export default {
    name: 'PowerByBzbs',
}
</script>
